import { SxProps, Theme } from '@mui/material/styles'
import { hoverBaseStyles } from '../base/hoverBase.styles'

export const firstSessionStyles = {
  root: {
    ...hoverBaseStyles.root,
  } as SxProps<Theme>,

  text: {
    color: 'info.main',
    ...hoverBaseStyles.textRegular,
  } as SxProps<Theme>,
}
